export function removeNullProperties(obj: any) {
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    const hasProperties = value && Object.keys(value).length > 0;
    if (value === null) {
      delete obj[key];
    } else if (typeof value !== "string" && hasProperties) {
      removeNullProperties(value);
    }
  });
  return obj;
}

export const camelToSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter: string) => `_${letter.toLowerCase()}`);

export const snakeCaseToCamelCase = (str: string) =>
  str
    .split("_")
    .reduce(
      (res: string, word: string, i: number) =>
        i === 0
          ? word.toLowerCase()
          : `${res}${word.charAt(0).toUpperCase()}${word
              .substr(1)
              .toLowerCase()}`,
      ""
    );

export function coalesceArrayToNull<Type>(
  arg: Array<Type> | undefined
): Array<Type> | null {
  const length = arg?.length ?? 0;
  if (arg != undefined && length > 0) {
    return arg;
  } else {
    return null;
  }
}
